import {
	Component,
	OnInit,
	ViewChild,
	ViewEncapsulation,
	OnDestroy,
	AfterViewInit,
	ElementRef,
	ContentChild,
} from '@angular/core';
import { CurrencyPipe } from '@angular/common';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';

import { Store, select } from '@ngrx/store';

import { ActivatedRoute, Router } from '@angular/router';
import { UrlService } from '@service/url/url.service';
import { SNACKBAR } from '@domain/constants/snackbar-setting';
import { UtilService } from '@service/util/util.service';
import {
	ContactsTable,
	HQ_LOCATION_PARSER,
	IS_NOT_EMPTY,
	IS_NOT_NULL_OR_UNDEFINED,
	IS_NULL_OR_UNDEFINED,
	NOTIFICATION_TYPES,
	ProjectCarrierMapDTO,
	ProjectDTO,
	RestService,
	PROJECT_CARRIER_MAP_STATUS,
	ProjectGroup,
	IS_EMPTY,
	Owner,
	INTEGRATION_TYPE,
	FORMAT_SCORE_PERCENTAGE,
} from 'cargo-chief-commons';
import { SegmentEventsConstants } from '@domain/constants/segment-events-constants';
import { SegmentWrapperService } from '@service/segmentWrapper/segment-wrapper.service';
import { UserSettingsService } from '@service/userSettings/user-settings.service';
import {
	CARGOCHIEF_KEYS,
	CARRIER_FEEDBACK_SETTINGS,
	MIN_PAGE_CONTAINER_WIDTH,
	MIN_WIDTH_CONTAINER_CLASS,
	CAPACITY_SEARCH_FILTER,
	RANGE_FILTERS,
} from '@domain/constants/app-variables';
import { Cargochief } from '@service/cargochief/cargochief.service';
import { FirebaseService } from '@service/firebase/firebase.service';
import { SharedService } from '@service/shared/shared.service';
import { ProjectHelperService } from '@service/projectHelper/project-helper.service';
import { AccountSettingsService } from '@service/accountSettings/account-settings.service';
import { CarrierSearchHelperService } from '@core/services/carrier-search-helper/carrier-search-helper.service';
import { environment } from '@environment/environment';
import { ProjectDetailsService } from '@service/projectDetails/project-details.service';
import { PricingFeedbackService } from '@service/pricingFeedback/pricing-feedback.service';
import { CapacitySearchFilterService } from '@service/capacitySearchFilter/capacity-search-filter.service';
import { PricingComponent } from '@shared/pricing/pricing.component';
import { RecommendedCarriersComponent } from '../recommended-carriers/recommended-carriers.component';
import { NotesService } from '@service/notesService/notes.service';
import { NoteType } from '@notes/note-list/note-list.component';
import { ProductsService } from '@service/products/products.service';
import { AccessCacheService } from '@service/access-cache/access-cache.service';
import { ProcuredCarriersComponent } from '../procured-carriers/procured-carriers.component';
import { BaseComponent } from '@shared/base/base.component';
import { takeUntil, take, distinctUntilChanged, skip } from 'rxjs/operators';
import { firstValueFrom } from 'rxjs';
import { CapacitySearchFilterComponent } from '../capacity-search-panel/capacity-search-filter/capacity-search-filter.component';
import { ProjectGroupsComponent } from '../project-groups/project-groups.component';

import { ProjectDetailsStore } from '../store/store/project-details.store';
import { RecommendedCarriersStore } from '../store/store/recommended-carriers-store';
import {
	RECOMMENDED_CARRIERS,
	PROJECT_GROUPS,
	PROJECT_CARRIER_MAP,
	PROJECT_DETAILS,
} from '../store/actions';
import { projectDetailsPageStateKey } from '../store/state';
import { AddToGroupComponent } from '../add-to-group/add-to-group.component';

import { Actions, ofType } from '@ngrx/effects';
import { ProjectDetailsEffects } from '../store/effects/project-details.effects';
import { RecommendedCarriersEffects } from '../store/effects/recommended-carriers.effects';
import { ERROR_HANDLING } from '../../store/actions/error-handling.actions';
import { ACTIVE_USERS } from '../../v2/project/projects-list/constants';
import { IntegrationService } from '@service/integration/integration.service';
import { BookingAssistantService } from '@service/booking-assistant/booking-assistant.service';

const NOTIFICATION_NAME = 'notification.name';

@Component({
	selector: 'app-project-details',
	templateUrl: './project-details.component.html',
	styleUrls: ['./project-details.component.scss'],
	providers: [CurrencyPipe],
	encapsulation: ViewEncapsulation.None,
})
export class ProjectDetailsComponent
	extends BaseComponent
	implements OnInit, OnDestroy, AfterViewInit
{
	@ViewChild('pricingComponent') pricingComponent: PricingComponent;
	@ViewChild('recommendedCarriersComponent')
	recommendedCarriersComponent: RecommendedCarriersComponent;
	@ViewChild('procuredCarriersComponent') procuredCarriersComponent: ProcuredCarriersComponent;
	@ViewChild('engagedCarriersComponent') engagedCarriersComponent: ProcuredCarriersComponent;
	@ViewChild('appCapacitySearchFilter') appCapacitySearchFilter: CapacitySearchFilterComponent;
	@ViewChild('projectGroups') projectGroupsComponent: ProjectGroupsComponent;

	@ViewChild('projectDetailsAndPricingContainer')
	projectDetailsAndPricingContainer: ElementRef<HTMLDivElement>;
	@ViewChild('pageContentContainer')
	pageContentContainer: ElementRef<HTMLDivElement>;

	projectId: string = null;
	projectDTO: ProjectDTO = null;
	projectCarrierMapList: Array<ProjectCarrierMapDTO> = [];

	PAGE = 0;
	// PAGE_SIZE = 10;
	carrierIds: Array<string> = null;
	isLaneDetailsProfileView: boolean = false;
	carrierLaneData: any = null;
	recentFeedbackList: any = null;
	contactList: ContactsTable[] = null;
	customerOnly: boolean = false;
	IS_NOT_EMPTY = IS_NOT_EMPTY;
	IS_NOT_NULL_OR_UNDEFINED = IS_NOT_NULL_OR_UNDEFINED;
	CARRIER_QUALITY_ENABLED!: boolean;

	totalNumberOfTasks: any;
	totalNumberOfNotes: any;

	NUMBER_OF_LANES: number = 0;

	selectedProjectCarrierMapIDs: Array<string> = [];

	tooltipMessage =
		'mc - a valid mc number (eg. mc:12345 or mc-12345),\n' +
		'dot - a valid dot number (eg. dot:12345 or dot-12345),\n' +
		'name - a valid business name';

	@ViewChild('tabGroup') tabGroup;

	environment = environment;
	searchTruckForm = null;
	isUpdatingProject: boolean = false;
	lanePricing: any = null;
	carrierIdsToFetchNotes: string[] = [];
	isCarrierRatesEnabled: boolean = false;

	// vars
	selectedCarrierIds: Array<string> = [];
	carrierFiltersModel = {
		originDeadhead: null,
		destinationDeadhead: null,
		powerUnits: 0,
		minLoadsPerWeek: 0,
		ratesOnly: false,
		carriersSearchText: '',
		carrierHQ: '',
		carrierSelected: 'All Carriers',
		capacitySearchSort: RANGE_FILTERS.SORT.MATCH,
	};
	carrierHQOptions: string[] = CAPACITY_SEARCH_FILTER.CARRIER_HQ;
	carriersFilterOptions: string[] = CAPACITY_SEARCH_FILTER.CARRIERS;
	usersList: Array<Owner> = [];
	activeUsersList: Array<Owner> = [];
	RANGE_FILTERS = RANGE_FILTERS;
	CARGOCHIEF_KEYS = CARGOCHIEF_KEYS;
	pageContentAfterViewInit: boolean = false;
	openedQualityObject;
	isCarrierVettingIntegrationEnabled!: boolean;

	// variable for component state
	greenScreensEnabled = false;
	onRecommendedTab: boolean = false;
	onEngagedTab: boolean = false;
	onProcuredTab: boolean = false;
	procuredTabCarriersList: ProjectCarrierMapDTO[] = [];
	engagedTabCarriersList: ProjectCarrierMapDTO[] = [];

	constructor(
		private urlService: UrlService,
		private activeRoute: ActivatedRoute,
		private restService: RestService,
		public utilService: UtilService,
		private segmentWrapper: SegmentWrapperService,
		public cargochief: Cargochief,
		private firebaseService: FirebaseService,
		private sharedService: SharedService,
		public projectHelperService: ProjectHelperService,
		public accountSettings: AccountSettingsService,
		public carrierSearchHelper: CarrierSearchHelperService,
		private projectDetailsService: ProjectDetailsService,
		private pricingFeedbackService: PricingFeedbackService,
		private notesService: NotesService,
		public productsService: ProductsService,
		private capacitySearchFilterService: CapacitySearchFilterService,
		public readonly projectDetailsStore: ProjectDetailsStore,
		public readonly recommendedCarriersStore: RecommendedCarriersStore,
		private store: Store,
		private actions$: Actions<any>,
		public userSettings: UserSettingsService,
		private dialog: MatDialog,
		public readonly projectDetailsEffects: ProjectDetailsEffects,
		public readonly recommendedCarriersEffects: RecommendedCarriersEffects,
		private router: Router,
		private accessCacheService: AccessCacheService,
		public integrationService: IntegrationService,
		public bookingAssistantService: BookingAssistantService
	) {
		super();
	}

	async ngOnInit() {
		if (!this.productsService.PROJECT_CARRIERS) {
			this.utilService.navigateToDefaultViewForUser();
		} else {
			this.utilService.checkIfUserRoleAdminOrOwnerOnly();

			this.usersList = ACTIVE_USERS(this.accessCacheService.getAccountUsers());
			this.activeUsersList = JSON.parse(JSON.stringify(this.usersList));
			this.store.dispatch(PROJECT_DETAILS.SET.USERS_LIST({ usersList: this.usersList }));

			this.activeRoute.queryParams.subscribe((params) => {
				if (IS_NULL_OR_UNDEFINED(params.fullProfile) && this.isLaneDetailsProfileView) {
					this.isLaneDetailsProfileView = false;
				}
			});

			this.activeRoute.params.subscribe((params: any) => {
				this.store.dispatch(PROJECT_DETAILS.PROJECT.SET_ID({ projectId: params['id'] }));
				this.projectId = params['id'];
				if (!this.utilService.isNullOrUndefined(this.projectId)) {
					setTimeout(() => {
						this.projectDTO = null;
						this.projectCarrierMapList = [];
						// this.PAGE = 0;
						this.tabGroup.selectedIndex = environment.ENABLE_ENGAGED_TAB_ON_PROJECT_DETAILS ? 2 : 1;
						this.searchTruckForm = null;
						this.store.dispatch(PROJECT_CARRIER_MAP.GET_ALL({}));
						this.store.dispatch(PROJECT_DETAILS.PROJECT.GET({}));
					});
				}
			});
			this.subscribeToFirebaseNotification();

			this.sharedService.getCarrierSearchEvent().subscribe((data: any) => {
				if (
					!this.utilService.isNullOrUndefined(data) &&
					!this.utilService.isNullOrUndefined(this.projectCarrierMapList)
				) {
					switch (data.type) {
						case 'note':
							this.projectCarrierMapList.map((projectCarrierMap: ProjectCarrierMapDTO) => {
								if (projectCarrierMap.carrier.id == data.value.capacitySearch.carrierId) {
									projectCarrierMap.notesCount = data.value.notesListComponent.totalNotes;
								}
							});
							break;
						case 'project':
							if (this.projectId == data.value.projectId) {
								setTimeout(() => {
									this.utilService.showSnackbar(
										'Project updated. Reloading this page.',
										SNACKBAR.WARNING,
										SNACKBAR.ACTION
									);
								}, 2500);
								setTimeout(() => {
									window.location.reload();
								}, 5000);
							}
							break;
					}
				}
			});
			const activeIntegrations = this.cargochief.getActiveIntegrations();
			this.greenScreensEnabled =
				IS_NOT_NULL_OR_UNDEFINED(activeIntegrations) &&
				activeIntegrations.includes(INTEGRATION_TYPE.GREEN_SCREENS);
		}
		this.isCarrierVettingIntegrationEnabled =
			this.integrationService.isCarrierVettingIntegrationEnabled();
		this.CARRIER_QUALITY_ENABLED = this.accountSettings.CARRIER_QUALITY;

		this.projectDetailsStore.loadingProjectCarrierMaps$
			.pipe(takeUntil(this.isDestroyed$), distinctUntilChanged())
			.subscribe((value) => {
				if (!value) {
					this.onTabChange();
				}
			});
	}

	ngAfterViewInit() {
		super.setDefaultPageWidth(
			'project details',
			MIN_WIDTH_CONTAINER_CLASS.CAPACITY_SEARCH,
			MIN_PAGE_CONTAINER_WIDTH.PROJECT_DETAILS
		);
		this.pageContentAfterViewInit = true;
		this.subscribeToStoreActions();
		this.initializeDeadheadFilters();
		this.setTabGroupsIndex();

		this.projectDetailsStore.projectDTO$
			.pipe(takeUntil(this.isDestroyed$), distinctUntilChanged())
			.subscribe((projectDTO) => {
				this.projectDTO = projectDTO;
				this.customerOnly =
					IS_NOT_NULL_OR_UNDEFINED(this.projectDTO) &&
					IS_EMPTY(this.projectDTO.originCity) &&
					IS_EMPTY(this.projectDTO.originState) &&
					IS_EMPTY(this.projectDTO.destCity) &&
					IS_EMPTY(this.projectDTO.destState) &&
					IS_EMPTY(this.projectDTO.equipmentType) &&
					IS_NOT_NULL_OR_UNDEFINED(this.projectDTO.customerDTO);
			});
	}

	ngOnChanges() {
		this.isCarrierRatesEnabled =
			environment.CARRIER_RATES &&
			this.productsService.CARRIER_RATES &&
			this.accountSettings.CARRIER_RATES;
	}

	subscribeToFirebaseNotification() {
		this.firebaseService.requestPermission();
		this.firebaseService.getNotificationData().subscribe((message: any) => {
			if (
				!this.utilService.isNullOrUndefined(message) &&
				!this.utilService.isNullOrUndefined(this.projectDTO) &&
				this.projectDTO.id == message['notification.projectId']
			) {
				let updatedMapIndex = -1;
				if (message[NOTIFICATION_NAME] == NOTIFICATION_TYPES.ProjectRateReceivedEmailCommand) {
					if (
						!this.utilService.isNullOrUndefined(this.projectCarrierMapList) &&
						this.projectCarrierMapList.length > 0
					) {
						this.projectCarrierMapList.map(
							(projectCarrierMap: ProjectCarrierMapDTO, index: number) => {
								if (projectCarrierMap.id == message['notification.projectCarrierMapId']) {
									projectCarrierMap.desiredPrice = message['notification.desiredPrice'];
									projectCarrierMap.carrierRespondedAt = message['notification.carrierRespondedAt'];
									projectCarrierMap.carrierNotAvailable =
										message['notification.carrierNotAvailable'];
									updatedMapIndex = index;
								}
							}
						);
					}
				}
				if (message[NOTIFICATION_NAME] == NOTIFICATION_TYPES.ProjectBestRateUpdatedCommand) {
					this.projectDTO.bestRate = message['notification.bestRate'];
				}
				if (message[NOTIFICATION_NAME] == NOTIFICATION_TYPES.CalculateProbabilityCommand) {
					this.projectDTO.probability = +message['notification.probability'];
				}
				if (message[NOTIFICATION_NAME] == NOTIFICATION_TYPES.CarrierOpenedEmail) {
					if (
						!this.utilService.isNullOrUndefined(this.projectCarrierMapList) &&
						this.projectCarrierMapList.length > 0
					) {
						this.projectCarrierMapList.map(
							(projectCarrierMap: ProjectCarrierMapDTO, index: number) => {
								if (projectCarrierMap.id == message['notification.projectCarrierMapId']) {
									projectCarrierMap.carrierLastOpenedEmailAt = new Date();
									updatedMapIndex = index;
								}
							}
						);
					}
				}
				if (message[NOTIFICATION_NAME] == NOTIFICATION_TYPES.CarrierNotAvailableRFPCommand) {
					if (
						!this.utilService.isNullOrUndefined(this.projectCarrierMapList) &&
						this.projectCarrierMapList.length > 0
					) {
						this.projectCarrierMapList.map(
							(projectCarrierMap: ProjectCarrierMapDTO, index: number) => {
								if (projectCarrierMap.id == message['notification.projectCarrierMapId']) {
									projectCarrierMap.carrierNotAvailable = true;
									projectCarrierMap.carrierRespondedAt = new Date();
									updatedMapIndex = index;
								}
							}
						);
					}
				}
				if (updatedMapIndex > -1) {
					this.projectCarrierMapList[updatedMapIndex] = Object.assign(
						{},
						this.projectCarrierMapList[updatedMapIndex]
					);
				}
			}
		});
	}

	openFullProfile(projectCarrierMap: any, event: MouseEvent) {
		if (!this.utilService.isNullOrUndefined(event) && event.shiftKey) {
			this.panelClicked(projectCarrierMap, event);
			return;
		}
		const carrier: any = Object.assign({}, projectCarrierMap.carrier);
		this.carrierLaneData = null;
		this.contactList = null;
		this.recentFeedbackList = null;
		this.isLaneDetailsProfileView = true;
		this.segmentWrapper.fireSegmentEvent(SegmentEventsConstants.user_viewed_full_profile, carrier);
		this.getCarrierContacts(carrier);
		this.getRecentFeedbackList(carrier.id);
		this.openedQualityObject =
			this.tabGroup.selectedIndex == 0
				? this.getRecommendedCarrierOpened()
				: this.getCarrierQualityObject(projectCarrierMap.carrier);
		this.openedQualityObject['firmDot'] = projectCarrierMap.carrier.dot;
		this.openedQualityObject['active'] = projectCarrierMap.carrier.active;
	}

	getCarrierContacts(carrier: any) {
		const contactsUrl = this.urlService.contactsUrl(carrier.id);
		this.restService.GET(contactsUrl).subscribe(
			(result) => {
				this.segmentWrapper.fireSegmentEvent(SegmentEventsConstants.contact_requested, result);
				this.contactList = result['data'];
				const accountCarrierMap = carrier?.accountCarrierMaps?.find(
					(acm) => acm.accountId == this.cargochief.ACCOUNT_ID
				);
				this.carrierLaneData = {
					lane: {
						businessName: carrier.businessName,
						customerCarrier:
							this.tabGroup.selectedIndex == 0
								? this.openedQualityObject.customerCarrier
								: IS_NOT_NULL_OR_UNDEFINED(accountCarrierMap),
						firmMc: carrier.mc,
						firmDot: carrier.dot,
						powerUnits: carrier.powerUnits,
						drivers: carrier.drivers,
						carrierId: carrier.id,
						carrierHQ: HQ_LOCATION_PARSER(carrier.city, carrier.state),
						hazmat: carrier.hazmat,
						hasTeams: carrier.hasTeams,
						hasTeamsUpdatedOn: carrier.hasTeamsUpdatedOn,
						vettingOverallDisplay: accountCarrierMap
							? accountCarrierMap?.vettingOverallDisplay
							: carrier?.vettingOverallDisplay,
						vettingAuthorityDisplay: accountCarrierMap
							? accountCarrierMap?.vettingAuthorityDisplay
							: carrier?.vettingAuthorityDisplay,
						vettingInsuranceDisplay: accountCarrierMap
							? accountCarrierMap?.vettingInsuranceDisplay
							: carrier?.vettingInsuranceDisplay,
						vettingOperationsDisplay: accountCarrierMap
							? accountCarrierMap?.vettingOperationsDisplay
							: carrier?.vettingOperationsDisplay,
						vettingOtherDisplay: accountCarrierMap
							? accountCarrierMap?.vettingOtherDisplay
							: carrier?.vettingOtherDisplay,
						vettingSafetyDisplay: accountCarrierMap
							? accountCarrierMap?.vettingSafetyDisplay
							: carrier?.vettingSafetyDisplay,
						lastVettingTime: accountCarrierMap
							? accountCarrierMap?.lastVettingTime
							: carrier.lastVettingTime,
					},
					contactList: this.contactList,
				};
			},
			(error) => {
				this.utilService.showSnackbar(
					'Cannot fetch contact list.',
					SNACKBAR.ERROR,
					SNACKBAR.ACTION
				);
				this.contactList = [];
			}
		);
	}

	getRecentFeedbackList(id: string) {
		const url = this.urlService.getCarrierFeedback(id, {
			pageSize: CARRIER_FEEDBACK_SETTINGS.PAGE_SIZE,
		});
		this.restService.GET(url).subscribe((response) => {
			this.recentFeedbackList = response['data'];
		});
	}

	fireSegmentEvent(projectId: string, carrierId: string, cIndex: number) {
		const payload = {
			carrier: {
				businessName: this.projectCarrierMapList[cIndex].carrier.businessName,
				carrierId: carrierId,
			},
			projectId: projectId,
			page: 'Project Details',
		};
		this.segmentWrapper.fireSegmentEvent(
			SegmentEventsConstants.user_added_carrier_to_projects,
			payload
		);
	}

	updateProject(isOwnerAssigned: boolean, updateMsg: string, projectDTO: ProjectDTO) {
		const { requireTeamsEnabled, requireTeamsDisabled } =
			this.projectDetailsService.isRequireTeamsUpdated({
				oldProjectDTO: this.projectDTO,
				newProjectDTO: projectDTO,
			});
		const url = this.urlService.addProject() + `${isOwnerAssigned ? '?&isOwnerUpdated=true' : ''}`;
		this.isUpdatingProject = true;
		this.restService.PUT(url, projectDTO).subscribe(
			async (result: any) => {
				this.projectDTO = this.projectHelperService.convertProjectCentsToDollars(result.data);
				this.utilService.showSnackbar(updateMsg, SNACKBAR.SUCCESS, SNACKBAR.ACTION);
				this.isUpdatingProject = false;
				if (requireTeamsEnabled || requireTeamsDisabled) {
					if (requireTeamsDisabled) {
						this.recommendedCarriersComponent?.initiateSearch();
						return;
					}
					const removeProcuredCarriersWithoutTeams =
						await this.projectDetailsService.showProcuredCarriersRemovalConfirmation();
					if (IS_NOT_NULL_OR_UNDEFINED(removeProcuredCarriersWithoutTeams)) {
						this.selectedProjectCarrierMapIDs =
							this.projectDetailsService.getProjectCarrierMapIdsWithoutTeams(
								this.projectCarrierMapList
							);
						if (this.selectedProjectCarrierMapIDs.length > 0) {
							this.removeProcuredCarriers();
						} else {
							this.recommendedCarriersComponent?.initiateSearch();
						}
					} else {
						this.recommendedCarriersComponent?.initiateSearch();
					}
				}
			},
			(error) => {
				this.store.dispatch(
					ERROR_HANDLING.HANDLE_PROJECT_UPDATE_ERROR({
						error,
						forAdd: false,
						defaultErrorMessage: 'Unable to update project now.',
					})
				);
				this.isUpdatingProject = false;
			}
		);
	}

	rfpCompleted(data) {
		if (IS_NOT_NULL_OR_UNDEFINED(data) && data) {
			this.projectDTO.rfpRequestedDate = new Date();
		}
	}

	panelClicked(projectCarrierMap: ProjectCarrierMapDTO, event: MouseEvent) {
		document.getSelection().removeAllRanges();
		if (!event.shiftKey) {
			if (this.selectedProjectCarrierMapIDs.length > 1) {
				this.selectedProjectCarrierMapIDs = [];
				this.selectedCarrierIds = [];
			}
			if (this.selectedProjectCarrierMapIDs.indexOf(projectCarrierMap.id) > -1) {
				this.selectedProjectCarrierMapIDs = [];
				this.selectedCarrierIds = [];
			} else {
				this.selectedProjectCarrierMapIDs = [];
				this.selectedCarrierIds = [];
				this.selectedProjectCarrierMapIDs.push(projectCarrierMap.id);
				this.selectedCarrierIds.push(projectCarrierMap.carrier.id);
			}
		} else {
			if (this.selectedProjectCarrierMapIDs.indexOf(projectCarrierMap.id) > -1) {
				const matchedIndex = this.selectedProjectCarrierMapIDs.indexOf(projectCarrierMap.id);
				this.selectedProjectCarrierMapIDs.splice(matchedIndex, 1);
				this.selectedCarrierIds = this.selectedCarrierIds.filter(
					(carrierId) => carrierId !== projectCarrierMap.carrier.id
				);
			} else {
				this.selectedProjectCarrierMapIDs.push(projectCarrierMap.id);
				this.selectedCarrierIds.push(projectCarrierMap.carrier.id);
			}
		}
		this.populateCarrierIdsToFetchNotes();
	}

	showPricingAndRecentTransactions(): boolean {
		return this.productsService.PRICING || this.productsService.RECENT_TRANSACTIONS;
	}

	populateSearchTruckForm() {
		this.searchTruckForm = this.projectDetailsService.getSearchTruckForm(this.projectDTO);
		const frequencyFilter = this.cargochief.getItem(CARGOCHIEF_KEYS.FREQUENCY_FILTER);
		if (IS_NOT_NULL_OR_UNDEFINED(frequencyFilter)) {
			const { minLoadsPerWeek } = JSON.parse(frequencyFilter);
			this.searchTruckForm.minLoadsPerWeek = this.carrierFiltersModel.minLoadsPerWeek =
				minLoadsPerWeek;
		}
	}

	async lanePricingCompleted(lanePricing: any) {
		this.lanePricing = lanePricing;
		const feedbackCount = this.cargochief.getItem(CARGOCHIEF_KEYS.FEEDBACK_COUNT);
		if (
			!this.utilService.isNullOrUndefined(this.lanePricing) &&
			this.pricingFeedbackService.searchLimitExceeded()
		) {
			if (
				IS_NULL_OR_UNDEFINED(feedbackCount) ||
				(IS_NOT_EMPTY(feedbackCount) && Number(feedbackCount) <= environment.PRICING_FEEDBACK_LIMIT)
			) {
				await this.pricingFeedbackService.showFeedbackModal({
					lanePricing: this.lanePricing,
					searchTruckForm: this.searchTruckForm,
				});
				this.resetNoOfSearchesWithoutFeedbackCounter();
				this.pricingComponent.rateFeedbackProvided = true;
			} else if (
				this.pricingFeedbackService.searchLimitExceeded() &&
				IS_NOT_NULL_OR_UNDEFINED(feedbackCount) &&
				Number(feedbackCount) > environment.PRICING_FEEDBACK_LIMIT
			) {
				this.sharedService.sendfeedbackNotificationEvent(true);
			}
		}
	}

	resetNoOfSearchesWithoutFeedbackCounter() {
		this.pricingFeedbackService.setNoOfSearchesWithoutFeedbackCounter(0);
	}

	populateCarrierIdsToFetchNotes(): void {
		this.carrierIdsToFetchNotes = [];
		if (
			IS_NOT_NULL_OR_UNDEFINED(this.selectedProjectCarrierMapIDs) &&
			this.selectedProjectCarrierMapIDs.length > 0
		) {
			this.projectCarrierMapList?.forEach((projectCarrierMap) => {
				if (
					IS_NOT_NULL_OR_UNDEFINED(
						this.selectedProjectCarrierMapIDs.find(
							(selectedProjectCarrierMapId) => selectedProjectCarrierMapId == projectCarrierMap.id
						)
					)
				) {
					this.carrierIdsToFetchNotes.push(projectCarrierMap.carrier.id);
				}
			});
		}
		if (IS_NOT_NULL_OR_UNDEFINED(this.selectedCarrierIds) && this.selectedCarrierIds.length > 0) {
			this.carrierIdsToFetchNotes = [...this.carrierIdsToFetchNotes, ...this.selectedCarrierIds];
		}
		this.populateVisibleCarrierIds();
	}

	// method called on tab change
	async onTabChange() {
		this.onRecommendedTab = this.isRecommendedTab();
		const loadingProjectCarrierMaps = await firstValueFrom(
			this.projectDetailsStore.loadingProjectCarrierMaps$
		);
		this.onEngagedTab = this.isEngagedTab({ loadingProjectCarrierMaps });
		this.onProcuredTab = this.isProcuredTab({ loadingProjectCarrierMaps });

		const projectGroups = await firstValueFrom(this.projectDetailsStore.projectGroups$);
		const procuredCarriersList = await firstValueFrom(
			this.projectDetailsStore.procuredCarriersList$
		);
		this.procuredTabCarriersList = this.getProcuredCarriersList({
			projectGroups,
			procuredCarriersList,
		});
		if (this.onRecommendedTab) {
			this.recommendedCarriersComponent.pannelWrapperComponent.calculateViewportSize();
		}
		if (this.onEngagedTab) {
			this.engagedCarriersComponent?.calculateViewportSize();
		}
		if (this.onProcuredTab) {
			this.projectGroupsComponent?.procuredCarriersComponent?.calculateViewportSize();
			this.procuredCarriersComponent?.calculateViewportSize();
		}
	}

	resetSelectedCarriers() {
		this.carrierIdsToFetchNotes = [];
		this.selectedProjectCarrierMapIDs = [];
		this.selectedCarrierIds = [];
		this.projectHelperService.sendSelectedCarriersResetEvent();
		if (this.recommendedCarriersComponent) {
			this.recommendedCarriersComponent.capacitySearchResults = [
				...this.recommendedCarriersComponent.capacitySearchResults,
			];
		}
		if (this.procuredCarriersComponent) {
			this.procuredCarriersComponent.step = undefined;
			this.procuredCarriersComponent.projectCarrierMapList = [
				...this.procuredCarriersComponent.projectCarrierMapList,
			];
		}
		if (this.projectGroupsComponent?.selectedProjectCarrierMapIds.length) {
			this.projectGroupsComponent.selectedProjectCarrierMapIds = [];
		}
	}

	populateVisibleCarrierIds() {
		if (IS_NOT_NULL_OR_UNDEFINED(this.tabGroup)) {
			let visibleCarrierIds = [];
			if (this.tabGroup.selectedIndex == 0) {
				const recommendedCarriersComponent = this.recommendedCarriersComponent;
				if (
					IS_NOT_NULL_OR_UNDEFINED(recommendedCarriersComponent.capacitySearchResults) &&
					recommendedCarriersComponent.capacitySearchResults.length > 0
				) {
					visibleCarrierIds = recommendedCarriersComponent.capacitySearchResults
						.filter((capacitySearchResult) =>
							IS_NOT_NULL_OR_UNDEFINED(capacitySearchResult.carrierId)
						)
						.map((capacitySearchResult) => capacitySearchResult.carrierId);
				}
			} else {
				if (
					IS_NOT_NULL_OR_UNDEFINED(this.projectCarrierMapList) &&
					this.projectCarrierMapList.length > 0
				) {
					visibleCarrierIds = this.projectCarrierMapList
						.filter((projectCarrierMap) => IS_NOT_NULL_OR_UNDEFINED(projectCarrierMap?.carrier?.id))
						.map((projectCarrierMap) => projectCarrierMap.carrier.id);
				}
			}
			this.notesService.sendVisibleCarriersUpdatedEvent(visibleCarrierIds);
		}
	}

	downloadCapacitySearchResultsCsv(): void {
		this.store.dispatch(
			RECOMMENDED_CARRIERS.CAPACITY_SEARCH.DOWNLOAD_CSV({
				capacitySearchResults:
					this.recommendedCarriersComponent?.pannelWrapperComponent?.capacitySearchResults,
				searchFormData: this.recommendedCarriersComponent?.searchFormData,
			})
		);
	}

	getNoteType(): NoteType {
		return this.carrierIdsToFetchNotes.length === 1 ? NoteType.CARRIER : NoteType.PROJECT;
	}

	engageWithCarriers() {
		this.recommendedToEngage(this.selectedCarrierIds);
	}

	removeEngagedCarriers() {
		if (this.userSettings.HIDE_ENGAGE_CARRIER_DIALOG) {
			this.store.dispatch(
				PROJECT_CARRIER_MAP.DELETE_PROJECT_CARRIER_MAP.DELETE({
					projectCarrierMapIDs: this.selectedProjectCarrierMapIDs,
				})
			);
		} else {
			this.store.dispatch(
				PROJECT_CARRIER_MAP.DELETE_PROJECT_CARRIER_MAP.START({
					projectCarrierMapIDs: this.selectedProjectCarrierMapIDs,
					noteType: this.getNoteType(),
				})
			);
		}
	}

	moveEngagedToProcured() {
		this.store.dispatch(
			PROJECT_CARRIER_MAP.ENGAGE_TO_PROCURE.CREATE({
				projectCarrierMapIds: this.selectedProjectCarrierMapIDs,
			})
		);
	}

	moveRecommendedToProcured() {
		this.store.dispatch(
			RECOMMENDED_CARRIERS.PROCURE_CARRIERS.CREATE({
				selectedCarrierIds: this.selectedCarrierIds,
			})
		);
	}

	showRemoveButtonOnProcuredTab(): boolean {
		return environment.ENABLE_ENGAGED_TAB_ON_PROJECT_DETAILS
			? this.tabGroup?.selectedIndex == 2
			: this.tabGroup?.selectedIndex == 1;
	}

	showProcuredTabOptions(tabIndex: number): boolean {
		if (environment.ENABLE_ENGAGED_TAB_ON_PROJECT_DETAILS) {
			return tabIndex == 2;
		}
		return tabIndex == 1;
	}

	createProjectGroup() {
		let projectCarrierMapIds = this.projectGroupsComponent?.ungroupedSelectedProjectCarrierMapIds
			.length
			? this.projectGroupsComponent?.ungroupedSelectedProjectCarrierMapIds
			: this.selectedProjectCarrierMapIDs;
		if (
			!projectCarrierMapIds.length &&
			this.projectGroupsComponent.createGroupFromUserGroupEnabled &&
			this.projectGroupsComponent.selectedProjectCarrierMapIds.length
		) {
			projectCarrierMapIds = [...this.projectGroupsComponent.selectedProjectCarrierMapIds];
		}
		if (projectCarrierMapIds.length) {
			this.store.dispatch(
				PROJECT_GROUPS.OPEN_DIALOG({
					projectCarrierMapIds,
					projectId: this.projectId,
				})
			);
		}
	}

	moveProjectGroups(direction: string) {
		this.store.dispatch(
			PROJECT_GROUPS.MOVE_GROUPS({
				groupIds: this.projectGroupsComponent.selectedProjectGroupIds,
				direction,
			})
		);
	}

	removeFormGroup() {
		this.store.dispatch(
			PROJECT_GROUPS.DELETE_CARRIER({
				projectCarrierMapIds: this.projectGroupsComponent.selectedProjectCarrierMapIds,
			})
		);
	}

	async deleteGroups() {
		this.store
			.select((state) => state[projectDetailsPageStateKey])
			.pipe(takeUntil(this.isDestroyed$), take(1))
			.subscribe(async (state) => {
				// determine if carriers in groups deleted can be moved to lower priority group
				const deletedGroupsList: ProjectGroup[] = state.projectGroups
					.filter(
						(group) => this.projectGroupsComponent.selectedProjectGroupIds.indexOf(group.id) !== -1
					)
					.sort((a, b) => (a.delayByMinutes > b.delayByMinutes ? 1 : -1));
				const highestPriorityInDeletedGroups =
					deletedGroupsList[deletedGroupsList.length - 1].delayByMinutes;
				const lowerPriorityGroups = state.projectGroups.filter(
					(group) => !group.systemGroup && group.delayByMinutes > highestPriorityInDeletedGroups
				);
				let deleteProjectGroupRequest = {
					ids: this.projectGroupsComponent.selectedProjectGroupIds,
					moveToGroupId: null,
				};
				if (lowerPriorityGroups.length) {
					const moveToResponse = await this.dialog
						.open(AddToGroupComponent, {
							width: '500px',
							panelClass: 'cargo_chief_dialog_container',
							data: {
								dialogTitle: 'Move to Group',
								projectGroups: lowerPriorityGroups,
								closeButtonText: 'Cancel',
								submitButtonText: 'Move to Group',
							},
						})
						.afterClosed()
						.toPromise();
					if (moveToResponse?.projectGroupId) {
						deleteProjectGroupRequest.moveToGroupId = moveToResponse.projectGroupId;
					} else {
						return;
					}
				}
				this.store.dispatch(PROJECT_GROUPS.DELETE(deleteProjectGroupRequest));
			});
	}

	removeProcuredCarriers() {
		this.store.dispatch(
			PROJECT_CARRIER_MAP.PROCURED.DELETE({
				projectCarrierMapIDs: this.selectedProjectCarrierMapIDs.concat(
					this.projectGroupsComponent.selectedProjectCarrierMapIds
				),
				noteType: this.getNoteType(),
			})
		);
	}

	subscribeToStoreActions() {
		this.actions$
			.pipe(
				takeUntil(this.isDestroyed$),
				ofType(
					PROJECT_GROUPS.CREATE_SUCCESS,
					PROJECT_GROUPS.DELETE_SUCCESS,
					PROJECT_GROUPS.DELETE_CARRIER_SUCCESS,
					PROJECT_GROUPS.MOVE_GROUPS_SUCCESS,
					PROJECT_GROUPS.GROUP_AND_DEFAULT_GROUP.SUCCESS,

					PROJECT_CARRIER_MAP.PROCURED.DELETE_SUCCESS,
					PROJECT_CARRIER_MAP.FILTER.COMPLETE,
					RECOMMENDED_CARRIERS.ENGAGE_WITH_CARRIERS.SUCCESS,
					RECOMMENDED_CARRIERS.PROCURE_CARRIERS.SUCCESS,
					PROJECT_DETAILS.PROCURED_CARRIERS.RELOAD,
					RECOMMENDED_CARRIERS.ENGAGE_WITH_CARRIERS.CLOSE
				)
			)
			.subscribe((response) => {
				document.getSelection().removeAllRanges();
				this.selectedProjectCarrierMapIDs = [];
				this.selectedCarrierIds = [];
				if (this.recommendedCarriersComponent?.pannelWrapperComponent) {
					this.recommendedCarriersComponent.pannelWrapperComponent.selectedCarrierIds = [];
					if (
						this.recommendedCarriersComponent?.pannelWrapperComponent?.capacitySearchResults?.length
					) {
						this.recommendedCarriersComponent.pannelWrapperComponent.setStep(null, null);
					}
				}
				if (this.projectGroupsComponent) {
					this.projectGroupsComponent.selectedProjectCarrierMapIds = [];
					this.projectGroupsComponent.ungroupedSelectedProjectCarrierMapIds = [];
					this.store
						.select((state) => state[projectDetailsPageStateKey])
						.pipe(takeUntil(this.isDestroyed$), take(1))
						.subscribe((state) => {
							const groupIds = state.projectGroups.map((group) => group.id);
							this.projectGroupsComponent.selectedProjectGroupIds =
								this.projectGroupsComponent.selectedProjectGroupIds.filter(
									(groupId) => groupIds.indexOf(groupId) !== -1
								);
						});
				}
			});
	}

	procuredCarriersSelectionUpdated() {
		this.carrierIdsToFetchNotes = this.projectGroupsComponent.selectedCarrierIds.concat(
			this.selectedCarrierIds
		);
	}

	initializeDeadheadFilters() {
		const userDHO = this.userSettings.SEARCH_TRUCK_ORIGIN_DEADHEAD_LIMIT;
		const userDHD = this.userSettings.SEARCH_TRUCK_DESTINATION_DEADHEAD_LIMIT;
		const DHO = this.cargochief.getItem(CARGOCHIEF_KEYS.ORIGIN_DEADHEAD_SLIDER),
			DHD = this.cargochief.getItem(CARGOCHIEF_KEYS.DESTINATION_DEADHEAD_SLIDER);
		let deadhead = {
			originDeadhead: null,
			destinationDeadhead: null,
		};
		if (!this.utilService.isNullOrUndefined(userDHO)) {
			deadhead.originDeadhead = userDHO;
		} else if (!this.utilService.isNullOrUndefined(DHO)) {
			deadhead.originDeadhead = JSON.parse(DHO);
		} else {
			deadhead.originDeadhead = 10;
		}
		if (!this.utilService.isNullOrUndefined(userDHD)) {
			deadhead.destinationDeadhead = userDHD;
		} else if (!this.utilService.isNullOrUndefined(DHO)) {
			deadhead.destinationDeadhead = JSON.parse(DHO);
		} else {
			deadhead.destinationDeadhead = 10;
		}
		// check from localstorage if deadhead filter exist, this is picked by request
		const { originDeadhead, destinationDeadhead } = this.capacitySearchFilterService.getDeadhead();
		if (originDeadhead) {
			deadhead.originDeadhead = originDeadhead;
		}
		if (destinationDeadhead) {
			deadhead.destinationDeadhead = destinationDeadhead;
		}
		this.carrierFiltersModel.originDeadhead = deadhead.originDeadhead;
		this.carrierFiltersModel.destinationDeadhead = deadhead.destinationDeadhead;
		this.setClientFiltersForCarriers();
	}

	setTabGroupsIndex() {
		this.projectDetailsStore.loadingProjectCarrierMaps$
			.pipe(takeUntil(this.isDestroyed$), distinctUntilChanged(), skip(2), take(3))
			.subscribe((loadingProjectCarrierMaps) => {
				if (!loadingProjectCarrierMaps) {
					this.store
						.select((state) => state[projectDetailsPageStateKey])
						.pipe(takeUntil(this.isDestroyed$), take(1))
						.subscribe((state) => {
							if (!state.procuredCarriersCount && this.tabGroup) {
								if (!environment.ENABLE_ENGAGED_TAB_ON_PROJECT_DETAILS) {
									this.tabGroup.selectedIndex = 0;
								} else {
									this.tabGroup.selectedIndex = state.engagedCarriersCount ? 1 : 0;
								}
							}
						});
				}
			});
	}

	sortRecommendedCarriers() {
		if (this.recommendedCarriersComponent?.pannelWrapperComponent?.filters) {
			this.store.dispatch(
				RECOMMENDED_CARRIERS.SET.CAPACITY_SEARCH_SORT({
					capacitySearchSort: this.carrierFiltersModel.capacitySearchSort,
				})
			);

			const filters = {
				column: this.carrierFiltersModel.capacitySearchSort,
				carrierHQ: '',
			};
			this.recommendedCarriersComponent.pannelWrapperComponent.filters = { ...filters };
			this.projectDetailsEffects.sortSearchList(this.carrierFiltersModel.capacitySearchSort);
		}
	}

	async addCarriersToGroup() {
		this.store
			.select((state) => state[projectDetailsPageStateKey])
			.pipe(takeUntil(this.isDestroyed$), take(1))
			.subscribe(async (state) => {
				let projectGroups = state.projectGroups.filter(
					(group) => group.id !== this.projectGroupsComponent.selectedGroup?.id
				);
				const moveToResponse = await this.dialog
					.open(AddToGroupComponent, {
						width: '500px',
						panelClass: 'cargo_chief_dialog_container',
						data: {
							dialogTitle: 'Add to Group',
							projectGroups: projectGroups,
							closeButtonText: 'Cancel',
							submitButtonText: 'Add to Group',
						},
					})
					.afterClosed()
					.toPromise();
				if (moveToResponse?.projectGroupId) {
					let projectGroupUpdateRequest = { projectGroups: [] },
						deleteGroupIds: string[] = [];

					// update carriers in expanded group
					projectGroupUpdateRequest.projectGroups.push({
						projectGroupId: this.projectGroupsComponent.selectedGroup.id,
						projectCarrierMapIdList:
							this.projectGroupsComponent.selectedGroup.projectCarrierMapsList
								.filter(
									(pcm) =>
										this.projectGroupsComponent.selectedProjectCarrierMapIds.indexOf(pcm.id) === -1
								)
								.map((pcm) => pcm.id),
					});
					// check if we should delete selected group
					if (!projectGroupUpdateRequest.projectGroups[0].projectCarrierMapIdList.length) {
						deleteGroupIds.push(projectGroupUpdateRequest.projectGroups[0].projectGroupId);
						projectGroupUpdateRequest.projectGroups = [];
					}
					// move carriers to new group
					const selectedGroup = state.projectGroups.find(
						(group) => group.id === moveToResponse.projectGroupId
					);
					projectGroupUpdateRequest.projectGroups.push({
						projectGroupId: moveToResponse.projectGroupId,
						projectCarrierMapIdList:
							this.projectGroupsComponent.selectedProjectCarrierMapIds.concat(
								selectedGroup.projectCarrierMapsList.map((pcm) => pcm.id)
							),
					});
					this.store.dispatch(
						PROJECT_GROUPS.ADD_TO_GROUP.ADD({
							updateGroups: projectGroupUpdateRequest,
							deleteGroupIds,
						})
					);
				}
			});
	}

	setOriginDeadhead(value) {
		let originDeadhead = this.carrierFiltersModel.originDeadhead;
		originDeadhead += value;
		if (originDeadhead >= 0) {
			this.carrierFiltersModel.originDeadhead = originDeadhead;
		}
		this.onDeadheadChange(
			CARGOCHIEF_KEYS.ORIGIN_DEADHEAD_SLIDER,
			this.carrierFiltersModel.originDeadhead
		);
	}

	setDestinatioDeadhead(value) {
		let destinationDeadhead = this.carrierFiltersModel.destinationDeadhead;
		destinationDeadhead += value;
		if (destinationDeadhead >= 0) {
			this.carrierFiltersModel.destinationDeadhead = destinationDeadhead;
		}
		this.onDeadheadChange(
			CARGOCHIEF_KEYS.ORIGIN_DEADHEAD_SLIDER,
			this.carrierFiltersModel.originDeadhead
		);
	}

	onDeadheadChange(key, value) {
		this.cargochief.setItem({ [key]: value });
	}

	setPowerUnits(value) {
		let minTruckCount = this.carrierFiltersModel.powerUnits;
		minTruckCount += value;
		if (minTruckCount >= 0) {
			this.carrierFiltersModel.powerUnits = minTruckCount;
		} else {
			this.carrierFiltersModel.powerUnits = 0;
		}
	}

	setMinLoadsPerWeek(value) {
		let minLoadsPerWeek = this.carrierFiltersModel.minLoadsPerWeek;
		minLoadsPerWeek += value;
		if (minLoadsPerWeek >= 0) {
			this.carrierFiltersModel.minLoadsPerWeek = minLoadsPerWeek;
		} else {
			this.carrierFiltersModel.minLoadsPerWeek = 0;
		}
	}

	removeHQFilter() {
		this.carrierFiltersModel.carrierHQ = '';
	}

	applyFilter() {
		this.store
			.select((state) => state[projectDetailsPageStateKey])
			.pipe(takeUntil(this.isDestroyed$), take(1))
			.subscribe(async (state) => {
				this.setClientFiltersForCarriers();

				if (this.tabGroup?.selectedIndex === 0) {
					// check if we should run capacity search
					if (
						this.carrierFiltersModel.originDeadhead !== state.originDeadhead ||
						this.carrierFiltersModel.destinationDeadhead !== state.destinationDeadhead ||
						this.carrierFiltersModel.minLoadsPerWeek !== state.minLoadsPerWeek
					) {
						this.recommendedCarriersComponent.initiateSearch();
					}
					// check for carrierHQ  filter
					if (this.carrierFiltersModel.carrierHQ !== state.carrierHQ) {
						if (this.carrierFiltersModel.carrierHQ.length) {
							this.recommendedCarriersEffects.filterByHQ(
								this.carrierFiltersModel.carrierHQ,
								this.recommendedCarriersComponent.searchFormData
							);
						} else {
							this.recommendedCarriersEffects.removeHQFilter();
						}
					}
				}
				this.store.dispatch(PROJECT_CARRIER_MAP.FILTER.APPLY({}));
			});
	}

	setClientFiltersForCarriers() {
		const textSplit = this.carrierFiltersModel.carriersSearchText.split(',');
		let payload = { mc: '', dot: '', businessName: '' };
		textSplit?.forEach((text) => {
			if (this.carrierSearchHelper.isKey(text, 'mc')) {
				payload.mc = this.carrierSearchHelper.splitOutValue(text);
			} else if (this.carrierSearchHelper.isKey(text, 'dot')) {
				payload.dot = this.carrierSearchHelper.splitOutValue(text);
			} else {
				payload.businessName = text.trim();
			}
		});
		this.store.dispatch(
			RECOMMENDED_CARRIERS.SET.CARRIER_SEARCH({
				originDeadhead: this.carrierFiltersModel.originDeadhead,
				destinationDeadhead: this.carrierFiltersModel.destinationDeadhead,
				powerUnits: this.carrierFiltersModel.powerUnits,
				minLoadsPerWeek: this.carrierFiltersModel.minLoadsPerWeek,
				ratesOnly: this.carrierFiltersModel.ratesOnly,
				mc: payload.mc,
				dot: payload.dot,
				businessName: payload.businessName,
				carrierHQ: this.carrierFiltersModel.carrierHQ,
				myCarriers: this.carrierFiltersModel.carrierSelected === CAPACITY_SEARCH_FILTER.CARRIERS[1],
				outOfNetworkCarriers:
					this.carrierFiltersModel.carrierSelected === CAPACITY_SEARCH_FILTER.CARRIERS[2],
				carrierSearchString: this.carrierFiltersModel.carriersSearchText,
			})
		);
	}

	isFilterChange(filters: any) {
		if (
			filters.originDeadhead === this.carrierFiltersModel.originDeadhead &&
			filters.destinationDeadhead === this.carrierFiltersModel.destinationDeadhead &&
			filters.powerUnits === this.carrierFiltersModel.powerUnits &&
			filters.minLoadsPerWeek === this.carrierFiltersModel.minLoadsPerWeek &&
			filters.ratesOnly === this.carrierFiltersModel.ratesOnly &&
			filters.carrierSearchString === this.carrierFiltersModel.carriersSearchText &&
			filters.carrierHQ === this.carrierFiltersModel.carrierHQ &&
			filters.myCarriers ===
				(this.carrierFiltersModel.carrierSelected === CAPACITY_SEARCH_FILTER.CARRIERS[1]) &&
			filters.outOfNetworkCarriers ===
				(this.carrierFiltersModel.carrierSelected === CAPACITY_SEARCH_FILTER.CARRIERS[2])
		) {
			return true;
		}
		return false;
	}

	navigateToCapacitySearch(): void {
		this.router.navigate([`capacity/`]);
	}

	async mergeGroups() {
		this.store
			.select((state) => state[projectDetailsPageStateKey])
			.pipe(takeUntil(this.isDestroyed$), take(1))
			.subscribe(async (state) => {
				const selectedProjectGroups = state.projectGroups.filter(
					(group) => this.projectGroupsComponent.selectedProjectGroupIds.indexOf(group.id) !== -1
				);
				let projectCarrierMapIdList: string[] = selectedProjectGroups[0].projectCarrierMapsList.map(
						(pcm) => pcm.id
					),
					deleteGroupIds: string[] = [],
					projectGroupUpdateRequest = { projectGroups: [] };
				selectedProjectGroups.forEach((group, index) => {
					if (index) {
						projectCarrierMapIdList = projectCarrierMapIdList.concat(
							group.projectCarrierMapsList.map((pcm) => pcm.id)
						);
						if (!group.systemGroup) {
							deleteGroupIds.push(group.id);
						}
					}
				});
				projectGroupUpdateRequest.projectGroups.push({
					projectGroupId: selectedProjectGroups[0].id,
					projectCarrierMapIdList,
				});

				this.store.dispatch(
					PROJECT_GROUPS.ADD_TO_GROUP.ADD({
						updateGroups: projectGroupUpdateRequest,
						deleteGroupIds,
					})
				);
			});
	}

	onRecommendedTabDrop(event: any) {
		if (!this.tabGroup?.selectedIndex) {
			return;
		}
		const selectedIds: string[] = this.getDroppedCarrierIds(event);
		if (this.tabGroup.selectedIndex === 2) {
			this.store.dispatch(
				PROJECT_CARRIER_MAP.PROCURED.DELETE({
					projectCarrierMapIDs: selectedIds,
					noteType: this.getNoteType(),
				})
			);
		} else {
			this.store.dispatch(
				PROJECT_CARRIER_MAP.DELETE_PROJECT_CARRIER_MAP.DELETE({
					projectCarrierMapIDs: selectedIds,
				})
			);
		}
	}

	onEngagedTabDrop(event: any) {
		if (this.tabGroup?.selectedIndex === 1) {
			return;
		}
		const selectedIds: string[] = this.getDroppedCarrierIds(event);
		if (!this.tabGroup.selectedIndex) {
			this.recommendedToEngage(selectedIds);
		} else {
			this.store.dispatch(
				PROJECT_CARRIER_MAP.PROCURED_TO_ENGAGED.CREATE({
					projectCarrierMapIds: selectedIds,
				})
			);
		}
	}

	onProcuredTabDrop(event: any) {
		if (this.showProcuredTabOptions(this.tabGroup.selectedIndex)) {
			return;
		}
		const selectedIds: string[] = this.getDroppedCarrierIds(event);
		if (!this.tabGroup.selectedIndex) {
			this.store.dispatch(
				RECOMMENDED_CARRIERS.PROCURE_CARRIERS.CREATE({
					selectedCarrierIds: selectedIds,
				})
			);
		} else {
			this.store.dispatch(
				PROJECT_CARRIER_MAP.ENGAGE_TO_PROCURE.CREATE({
					projectCarrierMapIds: selectedIds,
				})
			);
		}
	}

	getDroppedCarrierIds(event: any): string[] {
		event.preventDefault();
		return event.dataTransfer.getData('carrierId').split(',');
	}

	recommendedToEngage(selectedCarrierIds: string[]) {
		if (this.userSettings.HIDE_ENGAGE_CARRIER_DIALOG) {
			this.store.dispatch(
				RECOMMENDED_CARRIERS.ENGAGE_WITH_CARRIERS.CREATE({
					carrierIDs: selectedCarrierIds,
					desiredPrice: null,
					carrierRespondedAt: null,
					status: PROJECT_CARRIER_MAP_STATUS.IN_PROGRESS,
				})
			);
		} else {
			this.store.dispatch(
				RECOMMENDED_CARRIERS.ENGAGE_WITH_CARRIERS.START({
					selectedCarrierIds: selectedCarrierIds,
					noteType: this.getNoteType(),
					showRateForm: true,
					showNotes: true,
				})
			);
		}
	}

	editProjectGroup() {
		this.store
			.select((state) => state[projectDetailsPageStateKey])
			.pipe(takeUntil(this.isDestroyed$), take(1))
			.subscribe(async (state) => {
				const selectedGroupId = this.projectGroupsComponent.selectedProjectGroupIds[0];
				const selectedGroup = state.projectGroups.find((group) => group.id === selectedGroupId);
				const projectCarrierMapsList = selectedGroup.projectCarrierMapsList.map((pcm) => pcm.id);
				let delayByMinutesList = state.projectGroups.map((group) => group.delayByMinutes);
				delayByMinutesList.splice(delayByMinutesList.indexOf(selectedGroup.delayByMinutes), 1);
				if (selectedGroup) {
					this.store.dispatch(
						PROJECT_GROUPS.UPDATE_GROUP.UPDATE({
							editGroup: true,
							group: selectedGroup,
							projectId: selectedGroup?.projectId,
							projectCarrierMapIds: projectCarrierMapsList,
							delayByMinutesList,
							dialogTitle: 'Edit Group',
							submitButtonText: 'Update',
							groupsCount: state.projectGroups.length,
							groupNames: state.projectGroups
								.filter((group) => group.name && group.name !== selectedGroup.name)
								.map((group) => group.name.toLowerCase()),
						})
					);
				}
			});
	}

	async addDesiredRate() {
		this.store
			.select((state) => state[projectDetailsPageStateKey])
			.pipe(takeUntil(this.isDestroyed$), take(1))
			.subscribe(async (state) => {
				let projectCarrierMap = null,
					selectedPcmId = null;
				if (this.selectedProjectCarrierMapIDs?.length === 1) {
					selectedPcmId = this.selectedProjectCarrierMapIDs[0];
				} else if (this.projectGroupsComponent?.selectedProjectCarrierMapIds.length === 1) {
					selectedPcmId = this.projectGroupsComponent.selectedProjectCarrierMapIds[0];
				}
				projectCarrierMap = state.allProjectCarrierMapsList.find((pcm) => pcm.id === selectedPcmId);
				if (projectCarrierMap) {
					this.store.dispatch(PROJECT_CARRIER_MAP.UPDATE_RATE.OPEN_DIALOG({ projectCarrierMap }));
				}
			});
	}

	openBADialog() {
		this.store.dispatch(PROJECT_DETAILS.BA.OPEN_DIALOG({}));
	}

	moreThanOneProjectCarrierMapSelected(projectGroupsLength: number): boolean {
		if (this.tabGroup?.selectedIndex === 1) {
			return this.selectedProjectCarrierMapIDs.length !== 1;
		} else {
			return (
				(!projectGroupsLength && this.selectedProjectCarrierMapIDs.length !== 1) ||
				(projectGroupsLength &&
					this.projectGroupsComponent?.selectedProjectCarrierMapIds.length !== 1)
			);
		}
	}

	reportDataAction(dataType: string) {
		this.store
			.select((state) => state[projectDetailsPageStateKey])
			.pipe(takeUntil(this.isDestroyed$), take(1))
			.subscribe(async (state) => {
				let projectCarrierMap = null,
					selectedPcmId = null;
				if (this.selectedProjectCarrierMapIDs?.length === 1) {
					selectedPcmId = this.selectedProjectCarrierMapIDs[0];
				} else if (this.projectGroupsComponent?.selectedProjectCarrierMapIds.length === 1) {
					selectedPcmId = this.projectGroupsComponent.selectedProjectCarrierMapIds[0];
				}
				projectCarrierMap = state.allProjectCarrierMapsList.find((pcm) => pcm.id === selectedPcmId);
				if (projectCarrierMap) {
					this.engagedCarriersComponent?.reportDataAction(dataType, projectCarrierMap.carrier);
				}
			});
	}

	getFromRecommendedCarrierOrProjectCarrierMap(
		allProjectCarrierMapsList: ProjectCarrierMapDTO[],
		attribute: 'mc' | 'dot' | 'customerCarrier'
	) {
		const from =
			this.tabGroup.selectedIndex == 0 ? 'fromRecommendedCarrier' : 'fromProjectCarrierMap';
		const attributeMap = {
			mc: { fromRecommendedCarrier: 'firmMc', fromProjectCarrierMap: 'mc' },
			dot: { fromRecommendedCarrier: 'firmDot', fromProjectCarrierMap: 'dot' },
			customerCarrier: {
				fromRecommendedCarrier: 'customerCarrier',
				fromProjectCarrierMap: 'customerCarrier',
			},
		};
		const attributeToFetch = attributeMap[attribute][from];
		if (from == 'fromRecommendedCarrier') {
			const carrier = this.getRecommendedCarrierOpened();
			if (IS_NULL_OR_UNDEFINED(carrier)) {
				return null;
			}
			return carrier[attributeToFetch];
		} else {
			const projectCarrierMap = this.getProcuredCarrierOpened(allProjectCarrierMapsList);
			if (IS_NULL_OR_UNDEFINED(projectCarrierMap)) {
				return null;
			}
			return projectCarrierMap[attributeToFetch];
		}
	}

	getCarrierMc(allProjectCarrierMapsList: ProjectCarrierMapDTO[]) {
		return this.getFromRecommendedCarrierOrProjectCarrierMap(allProjectCarrierMapsList, 'mc');
	}

	getCarrierDot(allProjectCarrierMapsList: ProjectCarrierMapDTO[]) {
		return this.getFromRecommendedCarrierOrProjectCarrierMap(allProjectCarrierMapsList, 'dot');
	}

	getCarrierQuality(allProjectCarrierMapsList: ProjectCarrierMapDTO[]) {
		if (this.tabGroup.selectedIndex == 0) {
			const carrier = this.getRecommendedCarrierOpened();
			return carrier;
		} else {
			const projectCarrierMap = this.getProcuredCarrierOpened(allProjectCarrierMapsList);
			return this.getCarrierQualityObject(projectCarrierMap);
		}
	}

	getRecommendedCarrierOpened(): any {
		const carrier =
			this.recommendedCarriersComponent?.pannelWrapperComponent?.truckSearchResultCopy.find(
				(search) => search.carrierId == this.carrierIdsToFetchNotes[0]
			);
		return carrier;
	}

	getProcuredCarrierOpened(allProjectCarrierMapsList: ProjectCarrierMapDTO[]) {
		if (IS_NULL_OR_UNDEFINED(allProjectCarrierMapsList)) {
			return null;
		}
		const projectCarrierMap = allProjectCarrierMapsList?.find(
			(projectCarrierMap) => projectCarrierMap?.carrier?.id == this.carrierIdsToFetchNotes[0]
		);
		return projectCarrierMap?.carrier;
	}

	getSelectedCarrierForTab(allProjectCarrierMapsList: ProjectCarrierMapDTO[]) {
		if (this.tabGroup.selectedIndex == 0) {
			return this.getRecommendedCarrierOpened();
		} else {
			const accountId = this.cargochief.ACCOUNT_ID;
			const carrier = this.getProcuredCarrierOpened(allProjectCarrierMapsList);
			const accountCarrierMap = carrier?.accountCarrierMaps?.find(
				(acm) => acm.accountId == accountId
			);
			if (
				IS_NOT_NULL_OR_UNDEFINED(accountCarrierMap) &&
				IS_NOT_EMPTY(accountCarrierMap.vettingOverallDisplay)
			) {
				return accountCarrierMap;
			} else if (IS_NOT_EMPTY(carrier?.vettingOverallDisplay)) {
				return {
					ccBookingRateDisplay: FORMAT_SCORE_PERCENTAGE(carrier?.ccBookingRate),
					ccEngagementRateDisplay: FORMAT_SCORE_PERCENTAGE(carrier?.ccEngagementRate),
					ccFalloffRateDisplay: FORMAT_SCORE_PERCENTAGE(carrier?.ccFalloffRate),
					ccTotalBookedLoads: carrier?.ccTotalBookedLoads,
					ccScore: carrier?.ccScore,
					vettingAuthorityDisplay: carrier?.vettingAuthorityDisplay,
					vettingInsuranceDisplay: carrier?.vettingInsuranceDisplay,
					vettingOperationsDisplay: carrier?.vettingOperationsDisplay,
					vettingSafetyDisplay: carrier?.vettingSafetyDisplay,
					vettingOverallDisplay: carrier?.vettingOverallDisplay,
					lastVettingTime: carrier?.lastVettingTime,
				};
			}
			return {};
		}
	}

	vettingOverallDisplay(allProjectCarrierMapsList: ProjectCarrierMapDTO[]) {
		return this.getSelectedCarrierForTab(allProjectCarrierMapsList)?.vettingOverallDisplay;
	}

	vettingAuthorityDisplay(allProjectCarrierMapsList: ProjectCarrierMapDTO[]) {
		return this.getSelectedCarrierForTab(allProjectCarrierMapsList)?.vettingAuthorityDisplay;
	}

	vettingInsuranceDisplay(allProjectCarrierMapsList: ProjectCarrierMapDTO[]) {
		return this.getSelectedCarrierForTab(allProjectCarrierMapsList)?.vettingInsuranceDisplay;
	}

	vettingOperationsDisplay(allProjectCarrierMapsList: ProjectCarrierMapDTO[]) {
		return this.getSelectedCarrierForTab(allProjectCarrierMapsList)?.vettingOperationsDisplay;
	}

	vettingSafetyDisplay(allProjectCarrierMapsList: ProjectCarrierMapDTO[]) {
		return this.getSelectedCarrierForTab(allProjectCarrierMapsList)?.vettingSafetyDisplay;
	}

	vettingOtherDisplay(allProjectCarrierMapsList: ProjectCarrierMapDTO[]) {
		return this.getSelectedCarrierForTab(allProjectCarrierMapsList)?.vettingOtherDisplay;
	}

	infractionDetails(allProjectCarrierMapsList: ProjectCarrierMapDTO[]) {
		return this.getSelectedCarrierForTab(allProjectCarrierMapsList)?.infractionDetails;
	}

	formatCarrierVettingRate(rate: number | null | undefined): string {
		return FORMAT_SCORE_PERCENTAGE(rate);
	}

	getCarrierQualityObject(projectCarrierMap) {
		const accountCarrierMap = projectCarrierMap?.accountCarrierMaps?.find(
			(acm) => acm.accountId === this.cargochief.ACCOUNT_ID
		);
		return {
			ccBookingRateDisplay: this.formatCarrierVettingRate(accountCarrierMap?.ccBookingRate),
			ccEngagementRateDisplay: this.formatCarrierVettingRate(accountCarrierMap?.ccEngagementRate),
			ccFalloffRateDisplay: this.formatCarrierVettingRate(accountCarrierMap?.ccFalloffRate),
			ccTotalBookedLoads: accountCarrierMap?.ccTotalBookedLoads,
			ccScore: accountCarrierMap?.ccScore,
			vettingSource: accountCarrierMap?.vettingSource,
			vettingSourceId: accountCarrierMap?.vettingSourceId,
			carrierOnboardedOn: accountCarrierMap?.carrierOnboardedOn,
		};
	}

	getIsCarrierInNetwork(allProjectCarrierMapsList: ProjectCarrierMapDTO[]) {
		return this.getFromRecommendedCarrierOrProjectCarrierMap(
			allProjectCarrierMapsList,
			'customerCarrier'
		);
	}

	getLastVettingTime(allProjectCarrierMapsList: ProjectCarrierMapDTO[]) {
		return this.getSelectedCarrierForTab(allProjectCarrierMapsList)?.lastVettingTime;
	}

	getProcuredCarriersList(store): ProjectCarrierMapDTO[] {
		let result = [];
		if (store?.projectGroups?.length) {
			store.projectGroups.forEach((group) => {
				result = result.concat(group.projectCarrierMapsList);
			});
		}
		if (store?.procuredCarriersList?.length) {
			result = result.concat(store.procuredCarriersList);
		}
		return result;
	}

	isRecommendedTab(): boolean {
		return this.tabGroup?.selectedIndex == 0 && !this.carrierIdsToFetchNotes.length;
	}

	isEngagedTab(store: any): boolean {
		return (
			environment.ENABLE_ENGAGED_TAB_ON_PROJECT_DETAILS &&
			!this.carrierIdsToFetchNotes.length &&
			this.tabGroup?.selectedIndex == 1 &&
			!store.loadingProjectCarrierMaps
		);
	}

	isProcuredTab(store: any): boolean {
		return (
			(environment.ENABLE_ENGAGED_TAB_ON_PROJECT_DETAILS
				? this.tabGroup?.selectedIndex == 2
				: this.tabGroup?.selectedIndex == 1) &&
			!this.carrierIdsToFetchNotes.length &&
			!store.loadingProjectCarrierMaps
		);
	}

	addCarrierContact(): void {
		this.sharedService.sendAddNewProjectCarrierMapContactEvent({
			carrierId: this.carrierIdsToFetchNotes[0],
		});
	}

	exportProcuredCarriers(): void {
		this.store.dispatch(PROJECT_DETAILS.DOWNLOAD.PROCURED_CARRIERS({}));
	}

	exportEngagedCarriers(): void {
		this.store.dispatch(PROJECT_DETAILS.DOWNLOAD.ENGAGEED_CARRIERS({}));
	}

	ngOnDestroy(): void {
		super.ngOnDestroy();
		this.projectDetailsStore.clear();
		this.store.dispatch(PROJECT_DETAILS.RESET_STATE({}));
	}
}
